module.exports = __webpack_public_path__ + "static/spotify-2ef1f0a4b55a20330d80da182f023dcd.svg";